module.exports = "../../app/cells/pages/questions/question_courses/show.erb";